import * as yup from 'yup';

export const casePaymentRequest = yup.object().shape({
    paymentType: yup.string().required(),
    currency: yup.string().required(),
    amount: yup.number(),
    caseId: yup.string().required(),
})